import { h } from 'preact';
import PureComponent from './PureComponent';
import CandidateRow from './CandidateRow';
import cx from 'classnames';
import { changePartyName } from '../utils/election-utils';

class PartyColumn extends PureComponent {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {}

  render() {
    const { partyName, partyBallot } = this.props;

    // get the candidates
    let candidates = partyBallot;

    // we style stuff based on the party, so set the class so it gets different styles
    const rowClass = cx('seat__race', {
      'seat__race--Democrat': partyName == 'Democratic',
      'seat__race--Republican': partyName == 'Republican',
    });

    let candidateRow;

    if (candidates.length > 0) {
      candidateRow = (
        <div>
          {candidates.map(candidate => (
            <CandidateRow
              ballotName={candidate.candidate_name}
              party={candidate.party}
              isIncumbent={candidate.incumbent}
              isNoted={candidate.is_noted}
            />
          ))}
        </div>
      );
    } else {
      candidateRow = (
        <div class="race__candidates__no-candidates">
          No primary candidates running
        </div>
      );
    }

    return (
      <div class={rowClass}>
        <div class="race">
          <div class="race__candidates">
            <div class="seat__subtitle race__party-name">
              <h4>{changePartyName(partyName)}</h4>
            </div>
            {candidateRow}
          </div>
        </div>
      </div>
    );
  }
}

export default PartyColumn;
